module.exports = __webpack_public_path__ + "src/assets/img/focus_car.8ed287a7.svg";